import { VStack } from '@direct-frontend/components';
import { CallMeBanner } from '#features/CallMeBanner';
import { CommunicationBanner } from '#features/Communication';
import { CompanyNameModerationBanner } from '#features/CompanyNameModerationBanner';
import { OnboardingStepper } from '#features/OnboardingStepper';
import { StoreIsBannedBanner } from '#features/StoreIsBannedBanner';
import { useTopBarContext } from './lib/TopBarStateContext';
import { TOP_BAR_CONTENT_TYPES, TOP_BAR_LAYOUT } from './constants';
import { type TopBarContent } from './types';
import styles from './TopBar.module.css';

const PromoBanner = ({ content }: { content: TopBarContent }) => {
    if (content === TOP_BAR_CONTENT_TYPES.CALL_ME_BANNER) {
        return <CallMeBanner />;
    }

    return null;
};

const AlertBanner = ({ content }: { content: TopBarContent }) => {
    if (content === TOP_BAR_CONTENT_TYPES.COMPANY_NAME_MODERATION) {
        return <CompanyNameModerationBanner />;
    }

    if (content === TOP_BAR_CONTENT_TYPES.STORE_BANNED) {
        return <StoreIsBannedBanner />;
    }

    return null;
};

export const TopBar = () => {
    const { layout, content, communication, closeCommunication, actionCommunication, topBarRef } = useTopBarContext();

    const configuredBanner = communication ? (
        <div key={communication.id} className={styles.configuredBanner}>
            <CommunicationBanner
                communication={communication}
                onClose={closeCommunication}
                onAction={actionCommunication}
            />
        </div>
    ) : null;

    if (layout === TOP_BAR_LAYOUT.HIDDEN) {
        return null;
    }

    if (layout === TOP_BAR_LAYOUT.ALERT_COMPACT || layout === TOP_BAR_LAYOUT.ALERT_EXPANDED) {
        return (
            <VStack gap="8" className={styles.topBar}>
                <AlertBanner content={content} />
            </VStack>
        );
    }

    if (layout === TOP_BAR_LAYOUT.ONLY_ONBOARDING) {
        return (
            <VStack gap="8" className={styles.topBar}>
                <OnboardingStepper />
            </VStack>
        );
    }

    if (layout === TOP_BAR_LAYOUT.ONBOARDING_WITH_CONFIGURED) {
        return (
            <VStack gap="8" className={`${styles.topBar} ${styles.configured}`} ref={topBarRef}>
                {configuredBanner}
                <OnboardingStepper />
            </VStack>
        );
    }

    if (layout === TOP_BAR_LAYOUT.AFTER_ONBOARDING_CONFIGURED) {
        return (
            <VStack
                gap="8"
                className={`${styles.topBar} ${styles.configured} ${styles.configuredAfterOnboarding}`}
                ref={topBarRef}
            >
                {configuredBanner}
            </VStack>
        );
    }

    if (layout === TOP_BAR_LAYOUT.ONBOARDING_WITH_ADV) {
        return (
            <VStack gap="8" className={styles.topBar}>
                <PromoBanner content={content} />
                <OnboardingStepper />
            </VStack>
        );
    }

    return (
        <VStack gap="8" className={styles.topBar}>
            <PromoBanner content={content} />
        </VStack>
    );
};
